var React = require('react');

function Excel (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.001 23L1 20.692V3.278L14.001 1v22zm0 0v-2.308m5.397-17.444c.602 0 .602.51.602.78v15.825c0 .36-.27.63-.572.63H14V3.247h5.398z","stroke":"currentColor","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M6.426 12.166L4.65 8.36l1.716-.09 1.053 2.937L8.683 8.12 10.43 8l-2.077 4.106 2.077 4.196-1.836-.09-1.234-3.087-1.234 2.908-1.625-.09 1.926-3.777z","fill":"#fff","stroke":"currentColor","strokeWidth":".5","key":1})]);
}

Excel.defaultProps = {"viewBox":"0 0 21 24","fill":"none"};

module.exports = Excel;

Excel.default = Excel;
